import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterFolder'
})
export class FilterPipe implements PipeTransform {

  transform(item: any, searchValue?: string, property:string = "name") {
    if (!!searchValue) {
      return item.filter((value: any) => value[property].toLowerCase().includes(searchValue?.toLowerCase()));
    }
    return item
  }

}
